import { render, staticRenderFns } from "./EntradaSalidaEditar.vue?vue&type=template&id=4fe84506&scoped=true&"
import script from "./EntradaSalidaEditar.vue?vue&type=script&lang=ts&"
export * from "./EntradaSalidaEditar.vue?vue&type=script&lang=ts&"
import style0 from "./EntradaSalidaEditar.vue?vue&type=style&index=0&id=4fe84506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe84506",
  null
  
)

export default component.exports